import script from "./Precio.vue?vue&type=script&setup=true&lang=js"
export * from "./Precio.vue?vue&type=script&setup=true&lang=js"

import "./Precio.vue?vue&type=style&index=0&id=3aa0c607&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa0c607"]])

export default __exports__